import React, { Component } from 'react';
import styled from 'styled-components';
import { FaAngleLeft, FaAngleRight, FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';

const PaginationList = styled.ul`
    float: right;
    color: white;
    font-family: "GothamLight";
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: .25rem;
    
    @media print {
        color: black;
    }
`;

const PaginatedItem = styled.li`
    padding-right: 4px;
    font-size: 14px;
    cursor: pointer;
    // display: ${props => props.disabled ? 'none' : ''};
    display: block;
    // color: #83BED3;
    color: ${props => props.disabled ? '#969292' : '#e6e8e4'};
    // pointer-events: none;
    pointer-events: ${props => props.disabled ? 'none' : 'pointer'};
    opacity: ${props => props.disabled ? '0.6' : '1'};
`;

const SelectedPaginatedItem = styled(PaginatedItem) `
    // color: BLUE;
    color: #83BED3;
`;

class Paginator extends Component {
    render() {
        const pagesToDraw = [];
        
        let maxPages = 55;
        let spreadPages = parseInt(maxPages/2, 10);
		let minPage = 0;
        let maxPage = this.props.totalPages;

        if(this.props.totalPages > maxPages) {
	        if(this.props.totalPages - this.props.currentPage <= spreadPages ) {
	        	minPage = this.props.totalPages - maxPages;
	        } else if(this.props.currentPage < (spreadPages + 1) ) {
	        	minPage = 0;
	        	maxPage = maxPages;
	        }
	        else {
		        minPage = Math.max(0,this.props.currentPage-(spreadPages ) );
		        maxPage = Math.min(this.props.totalPages, this.props.currentPage+(spreadPages + 1) );
	        }
        }

        for (let page = minPage; page < maxPage; page++) {
            let currentPageSelection = this.props.currentPage === page;

            const p = currentPageSelection ?
                <SelectedPaginatedItem key={page} >
                    <a onClick={() => this.props.setPage(page)}>{page + 1}</a>
                </SelectedPaginatedItem>
                :
                <PaginatedItem key={page}>
                    <a onClick={() => this.props.setPage(page)}>{page + 1}</a>
                </PaginatedItem>;

            pagesToDraw.push(p);
        }

        const disabledOnFirstPageClass = this.props.currentPage === 0;
        const disabledOnLastPage = this.props.currentPage === this.props.totalPages - 1;

        return <PaginationList>
            <PaginatedItem disabled={disabledOnFirstPageClass} >
                <a disabled={disabledOnFirstPageClass} onClick={() => this.props.setPage(0)}> <FaAngleDoubleLeft style={{
                    fontSize: '16px',
                    marginTop: '2px',
                }} /> </a>
            </PaginatedItem>
            <PaginatedItem disabled={disabledOnFirstPageClass}>
                <a disabled={disabledOnFirstPageClass} onClick={() => this.props.setPage(this.props.currentPage - 1)}><FaAngleLeft style={{
                    fontSize: '16px',
                    marginTop: '2px',
                }} /></a>
            </PaginatedItem>
            {pagesToDraw}
            <PaginatedItem disabled={disabledOnLastPage}>
                <a onClick={() => this.props.setPage(this.props.currentPage + 1)}><FaAngleRight style={{
                    fontSize: '16px',
                    marginTop: '2px',
                }} /></a>
            </PaginatedItem>
            <PaginatedItem disabled={disabledOnLastPage}>
                <a onClick={() => this.props.setPage(this.props.totalPages - 1)}> <FaAngleDoubleRight style={{
                    fontSize: '16px',
                    marginTop: '2px',
                }} /> </a>
            </PaginatedItem>
        </PaginationList>
    }
}


export default Paginator;


// WEBPACK FOOTER //
// ./src/hoc/Paginator/Paginator.js